import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { HeaderFieldProps } from './types'

/**
 * A single field row within an EntityHeader column.
 * Displays a label and value side by side.
 */
const HeaderField: FC<HeaderFieldProps> = ({
  label,
  value,
  getColor,
  format,
  truncate = false,
  fontSize,
  theme,
}) => {
  // Format the value if a formatter is provided
  const displayValue = format ? format(value) : value

  // Get color if a color function is provided
  const textColor = getColor ? getColor(value) : theme.palette.text.primary

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
      }}
    >
      <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
        {label}
      </Typography>
      <Typography
        sx={{
          textAlign: 'left',
          color: textColor,
          fontSize: fontSize ?? 'inherit',
          ...(truncate && {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }),
        }}
      >
        {displayValue ?? '—'}
      </Typography>
    </Box>
  )
}

export default HeaderField
